import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import security from "../../services/security.js";

class JobsearchController {
  constructor(
    $http,
    $localStorage,
    $state,
    AuthService,
    SecurityService,
    TrackingService,
    $rootScope,
    $scope,
    $location,
    $timeout,
    $window,
    $companies,
    Messagingv2Service,
    EventsService
  ) {
    this.name = "jobsearch";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$rootScope = $rootScope;
    this.$security = SecurityService;
    this.$window = $window;
    this.$timeout = $timeout;
    this.$events = EventsService;
    this.currentUser = this.$auth.getUserData();
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$tracking = TrackingService;
    this.$location = $location;
    this.$messagingv2 = Messagingv2Service;
    this.$companies = $companies;

    this.expandedFilter = false;
    this.expandedFilterStyles = {};
    this.expandedFilters = {};
    this.expandedFilterStylesMany = {
      1: {},
      2: {},
      3: {},
    };
    this.expandedMobile = false;
    this.expandedMobileStyles = {};
    this.selectedFilters = [];
    this.selectedJobbleTypes = [];
    this.selectedCompanies = [];
    this.companies = [];
    this.selectedLocations = [];
    this.locations = [];
    this.radius = "25";
    this.state = 1;

    this.dynamicFilters = [];

    this.showCategoryMore = false;
    this.showCompanyMore = false;
    this.showLocationMore = false;

    this.SetJobSearchCompaniesListener = this.$rootScope.$on("SetJobSearchCompanies", ($event, params) => {
      this.$timeout(() => {
        this.companies = params;

        this.calculateMoreOrLessToggle();

        if (this.selectedCompanies.length) {
          this.selectedCompanies = this.selectedCompanies.filter((value) => {
            return params.indexOf(value) !== -1;
          });

          this.$rootScope.$emit("SetCompanyFilters", this.selectedCompanies);
        }
      });
    });

    this.SetJobSearchLocationsListener = this.$rootScope.$on("SetJobSearchLocations", ($event, params) => {
      this.$timeout(() => {
        this.locations = params;

        this.calculateMoreOrLessToggle();

        if (this.selectedLocations.length) {
          this.selectedLocations = this.selectedLocations.filter((value) => {
            return params.indexOf(value) !== -1;
          });

          this.$rootScope.$emit("SetLocationFilters", this.selectedLocations);
        }
      });
    });

    this.DynamicSuggestedFiltersListender = this.$rootScope.$on("DynamicSuggestedFilters", ($event, params) => {
      this.$timeout(() => {
        console.log("New filters", params);

        const sameList = _.isEqual(_.sortBy(this.dynamicFilters), _.sortBy(params));

        console.log("Same filters?:", sameList);

        if (sameList) return console.log("Skipping filter update");

        this.dynamicFilters = params;
        if (this.dynamicFilters && this.dynamicFilters.length) {
          this.dynamicFilters = this.dynamicFilters.map((f) => {
            return f.toLowerCase();
          });

          this.selectedFilters.forEach((filter) => {
            filter = filter.toLowerCase();
            console.log(filter);

            if (this.dynamicFilters.indexOf(filter) === -1) {
              console.log(this.dynamicFilters);
              this.selectedFilters = this.selectedFilters.filter(function (value, index, arr) {
                return value.toLowerCase() !== filter;
              });
            }
          });

          console.log(this.selectedFilters);

          this.$timeout(() => {
            this.calculateMoreOrLessToggle();
          });
        }
      });
    });

    this.$scope.$on("$destroy", this.SetJobSearchCompaniesListener);
    this.$scope.$on("$destroy", this.SetJobSearchLocationsListener);
    this.$scope.$on("$destroy", this.DynamicSuggestedFiltersListender);
  }

  setState(state) {
    this.$timeout(() => {
      this.state = state;
      this.$timeout(() => {
        this.calculateMoreOrLessToggle();
      });
    });
  }

  toggleFilter(num) {
    this.expandedFilters = this.expandedFilters || {};
    this.expandedFilterStylesMany = this.expandedFilterStylesMany || {};

    this.expandedFilters[num] = !this.expandedFilters[num];

    if (this.expandedFilters[num]) {
      this.expandedFilterStylesMany[num] = {
        container: {
          height: "auto",
          paddingBottom: "25px",
        },
        toggles: {
          height: "auto",
        },
        toggle: {
          marginBottom: "9px",
        },
        more: {
          top: "auto",
          bottom: "34px",
        },
      };
    } else {
      this.expandedFilterStylesMany[num] = {};
    }
  }

  toggleLocation(location) {
    if (this.selectedLocations.indexOf(location) !== -1) {
      this.selectedLocations = this.selectedLocations.filter(function (value, index, arr) {
        return value !== location;
      });
    } else {
      this.selectedLocations.push(location);
      this.$tracking.reportClickLocationFilter("job board", location);
    }

    this.$rootScope.$emit("SetLocationFilters", this.selectedLocations);
  }

  toggleCompany(company) {
    if (this.selectedCompanies.indexOf(company) !== -1) {
      this.selectedCompanies = this.selectedCompanies.filter(function (value, index, arr) {
        return value !== company;
      });
    } else {
      this.selectedCompanies.push(company);
      this.$tracking.reportClickCompanyFilter("job board", company);
    }

    this.$rootScope.$emit("SetCompanyFilters", this.selectedCompanies);
  }

  toggleTag(tag) {
    if (this.selectedFilters.indexOf(tag) !== -1) {
      this.selectedFilters = this.selectedFilters.filter(function (value, index, arr) {
        return value !== tag;
      });
    } else {
      this.selectedFilters.push(tag);

      this.$tracking.reportJobsBoardNavBarFilterClick({
        secondary_name: tag,
      });
      this.$tracking.reportClickCategoryFilter("job board", tag);
    }

    this.setJobbleTypes(this.selectedFilters, 1, 1);
  }

  clearFilters() {
    if (this.selectedFilters.length === 0) return;
    this.selectedFilters = [];
    this.selectedJobbleTypes = [];
    this.setJobbleTypes(this.selectedFilters, 1, 1);
  }

  clearCompanies() {
    if (this.selectedCompanies.length === 0) return;

    this.selectedCompanies = [];
    this.$rootScope.$emit("SetCompanyFilters", this.selectedCompanies);
  }

  clearLocations() {
    if (this.selectedLocations.length === 0) return;

    this.selectedLocations = [];
    this.$rootScope.$emit("SetLocationFilters", this.selectedLocations);
  }

  setRadius() {
    console.warn(this.radius);
    this.$rootScope.$emit("SetSearchRadius", this.radius);
  }

  toggleMobileFilters() {
    this.expandedMobile = !this.expandedMobile;

    if (this.expandedMobile) {
      this.calculateMoreOrLessToggle();
      this.expandedMobileStyles = {
        toggle: {
          display: "none",
        },
        overall: {
          display: "block",
        },
      };

      document.body.style.position = "fixed";
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.webkitOverflowScrolling = "auto";
    } else {
      this.expandedMobileStyles = {};
      this.expandedFilterStyles = {};
      this.expandedFilter = false;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.webkitOverflowScrolling = "";
    }
  }

  calculateMoreOrLessToggle() {
    const categoryFilterContainer = document.getElementById("category-filter-holder");
    const companyFilterContainer = document.getElementById("company-filter-holder");
    const locationFilterContainer = document.getElementById("location-filter-holder");

    this.$timeout(() => {
      if (categoryFilterContainer && categoryFilterContainer.scrollHeight) {
        this.showCategoryMore =
          categoryFilterContainer.scrollHeight > 700 ? categoryFilterContainer.scrollHeight > 50 : categoryFilterContainer.scrollHeight > 100;
      }

      if (companyFilterContainer && companyFilterContainer.scrollHeight) {
        this.showCompanyMore =
          companyFilterContainer.scrollHeight > 700 ? companyFilterContainer.scrollHeight > 50 : companyFilterContainer.scrollHeight > 100;
      }

      if (locationFilterContainer && locationFilterContainer.scrollHeight) {
        this.showLocationMore =
          locationFilterContainer.scrollHeight > 700 ? locationFilterContainer.scrollHeight > 50 : locationFilterContainer.scrollHeight > 100;
      }
    });
  }
}

JobsearchController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "security",
  "tracking",
  "$rootScope",
  "$scope",
  "$location",
  "$timeout",
  "$window",
  "companies",
  "messagingv2",
  "events",
];

export default JobsearchController;



// WEBPACK FOOTER //
// ./client/app/common/jobsearch/jobsearch.controller.js